import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsOfUse = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center text-gray-600 hover:text-gray-900 transition-colors"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        <div className="bg-white rounded-lg shadow-sm p-6 md:p-8">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">Terms of Use</h1>
          <p className="text-sm text-gray-500 mb-8"><strong>Effective Date:</strong> January 1, 2025</p>

          <div className="prose prose-gray max-w-none">
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-700 mb-6">
              By accessing and using Salesqualifyd (operated by BALLSPARK TECHNOLOGIES PRIVATE LIMITED), you accept and agree to be bound by these Terms of Use. If you do not agree to these terms, please do not use our service.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">2. Service Description</h2>
            <p className="text-gray-700 mb-6">
              Salesqualifyd provides AI-powered market research report generation and CRM tools for businesses. Our Beta V1 offering provides lifetime access to core features for a one-time payment of $97.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">3. User Accounts</h2>
            <p className="text-gray-700 mb-4">You are responsible for:</p>
            <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
              <li>Maintaining the confidentiality of your account credentials</li>
              <li>All activities that occur under your account</li>
              <li>Notifying us immediately of any unauthorized use</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">4. Payment Terms</h2>
            <p className="text-gray-700 mb-6">
              Beta V1 access requires a one-time payment of $97. Managed services pricing is custom and determined through consultation with our sales team. All payments are processed securely through PayPal or Razorpay.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">5. Acceptable Use</h2>
            <p className="text-gray-700 mb-4">You agree not to:</p>
            <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
              <li>Use the service for any illegal purpose</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Share your account with others</li>
              <li>Reverse engineer or attempt to extract source code</li>
              <li>Use automated means to access the service without permission</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">6. Intellectual Property</h2>
            <p className="text-gray-700 mb-6">
              All content, features, and functionality of Salesqualifyd are owned by us and are protected by copyright, trademark, and other intellectual property laws. Reports generated using our service are provided for your use, but the underlying technology remains our property.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">7. Disclaimer of Warranties</h2>
            <p className="text-gray-700 mb-6">
              The service is provided "as is" without warranties of any kind. We do not guarantee that the service will be uninterrupted, secure, or error-free. Market research reports are generated using AI and should be used as guidance, not as definitive market analysis.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">8. Limitation of Liability</h2>
            <p className="text-gray-700 mb-6">
              To the maximum extent permitted by law, BALLSPARK TECHNOLOGIES PRIVATE LIMITED shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of the service.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">9. Changes to Terms</h2>
            <p className="text-gray-700 mb-6">
              We reserve the right to modify these terms at any time. Continued use of the service after changes constitutes acceptance of the new terms.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">10. Contact Information</h2>
            <p className="text-gray-700 mb-4">
              For questions about these Terms of Use, contact us at:
            </p>
            <div className="bg-gray-50 rounded-lg p-6 mb-6">
              <p className="font-semibold text-gray-900 mb-2">BALLSPARK TECHNOLOGIES PRIVATE LIMITED</p>
              <p className="text-gray-700 text-sm space-y-1">
                Suite #315 Viya Workspaces<br />
                36/1, Raghav Towers<br />
                Amman Nagar, Saravanampatti<br />
                Coimbatore 641035<br />
                <br />
                Phone: <a href="tel:+919789499945" className="text-red-800 hover:text-red-900">+91 97894 99945</a><br />
                Email: <a href="mailto:legal@salesqualifyd.com" className="text-red-800 hover:text-red-900">legal@salesqualifyd.com</a>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="bg-gray-900 text-white py-6 md:py-8 mt-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-xs sm:text-sm text-gray-400">
            © 2025 BALLSPARK TECHNOLOGIES PRIVATE LIMITED. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;
